module.exports = __webpack_public_path__ + "media/assets/images/SYB-promo-vday-8d46c26dc196e6c8c997058efb027625.png";